import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { numSequence } from '@app/shared/utils/num-sequence';

@Component({
  selector: 'app-skeleton-route',
  templateUrl: './skeleton-route.component.html',
})
export class SkeletonRouteComponent implements OnChanges {
  @Input() count = 1;
  isCircle = true;
  _avatarWidth = '16px';
  _avatarHeight = '16px';
  _titleWidth = '100%';
  _titleHeight = '20px';

  numSequence = numSequence;

  ngOnChanges(changes: SimpleChanges): void {
    this.count = changes['count']?.currentValue;
  }
}
